const Mutations = Object.freeze({
	SET_GRID_VIEWS: 'gridsModule/gridsPage/SET_GRID_VIEWS',
	SET_GRID_VIEW: 'gridsModule/gridsPage/SET_GRID_VIEW',
	SET_QUICK_FILTER: 'gridsModule/gridsPage/SET_QUICK_FILTER',
	SET_ADVANCED_FILTER: 'gridsModule/gridsPage/SET_ADVANCED_FILTER',
	SET_SORTING: 'gridsModule/gridsPage/SET_SORTING',
	SET_ROWS_PER_PAGE: 'gridsModule/gridsPage/SET_ROWS_PER_PAGE',
	SET_PAGE: 'gridsModule/gridsPage/SET_PAGE',
	SET_COLUMNS: 'gridsModule/gridsPage/SET_COLUMNS',
	SET_LOADING: 'gridsModule/gridsPage/SET_LOADING',
	SET_GRID_DATA: 'gridsModule/gridsPage/SET_GRID_DATA',
	SET_IRIS_USER_METADATA: 'gridsModule/gridsPage/SET_IRIS_USER_METADATA',
	SET_TOTAL_COUNT: 'gridsModule/gridsPage/SET_TOTAL_COUNT',
	SET_TOTAL_COUNT_DELETE: 'gridsModule/gridsPage/SET_TOTAL_COUNT_DELETE',
	REPLACE_GRID_VIEW: 'gridsModule/gridsPage/REPLACE_GRID_VIEW',
	UPDATE_GRID_VIEWS: 'gridsModule/gridsPage/UPDATE_GRID_VIEWS',
	DELETE_ASSET: 'gridsModule/gridsPage/DELETE_ASSET',
	DELETE_ASSETS: 'gridsModule/gridsPage/DELETE_ASSETS',
	ADD_GRID_VIEW: 'gridsModule/gridsPage/ADD_GRID_VIEW',
	REMOVE_GRID_VIEW: 'gridsModule/gridsPage/REMOVE_GRID_VIEW',
});
export const Actions = Object.freeze({
	CLEAR: 'gridsModule/gridsPage/CLEAR',
	LOAD_GRID_VIEW: 'gridsModule/gridsPage/LOAD_GRID_VIEW',
	LOAD_GRID_VIEW_DELETED: 'gridsModule/gridsPage/LOAD_GRID_VIEW_DELETED',
	LOAD_GRID_DATA: 'gridsModule/gridsPage/LOAD_GRID_DATA',
	SET_DEFAULT_GRID_VIEW: 'gridsModule/gridsPage/SET_DEFAULT_GRID_VIEW',
	SET_GLOBAL_GRID_VIEW: 'gridsModule/gridsPage/SET_GLOBAL_GRID_VIEW',
	SAVE_GRID_VIEW: 'gridsModule/gridsPage/SAVE_GRID_VIEW',
	UPDATE_GRID_VIEW: 'gridsModule/gridsPage/UPDATE_GRID_VIEW',
	UPDATE_ROWS_PER_PAGE: 'gridsModule/gridsPage/UPDATE_ROWS_PER_PAGE',
	UPDATE_PAGE: 'gridsModule/gridsPage/UPDATE_PAGE',
	UPDATE_SORTING: 'gridsModule/gridsPage/UPDATE_SORTING',
	UPDATE_QUICK_FILTER: 'gridsModule/gridsPage/UPDATE_QUICK_FILTER',
	UPDATE_ADVANCED_FILTER: 'gridsModule/gridsPage/UPDATE_ADVANCED_FILTER',
	UPDATE_GRID_VIEW_FIELDS: 'gridsModule/gridsPage/UPDATE_GRID_VIEW_FIELDS',
	DELETE_GRID_VIEW: 'gridsModule/gridsPage/DELETE_GRID_VIEW',
	DELETE_ASSET: 'gridsModule/gridsPage/DELETE_ASSET',
	DELETE_BULK_ASSETS: 'gridsModule/gridsPage/ DELETE_BULK_ASSETS',
	EXPORT_CURRENT_GW_PAGE: 'gridsModule/gridsPage/EXPORT_CURRENT_GW_PAGE',
	EXPORT_ALL_DATA: 'gridsModule/gridsPage/EXPORT_ALL_DATA',
});
export const Getters = Object.freeze({
	GRID_VIEW: 'gridsModule/gridsPage/GRID_VIEW',
	DEFAULT_GRID_VIEW: 'gridsModule/gridsPage/DEFAULT_GRID_VIEW',
	PAGE: 'gridsModule/gridsPage/PAGE',
	ROWS_PER_PAGE: 'gridsModule/gridsPage/ROWS_PER_PAGE',
	VISIBLE_COLUMNS: 'gridsModule/gridsPage/VISIBLE_COLUMNS',
	HIDDEN_COLUMNS: 'gridsModule/gridsPage/HIDDEN_COLUMNS',
	TOTAL_COUNT: 'gridsModule/gridsPage/TOTAL_COUNT',
	GRID_DATA: 'gridsModule/gridsPage/GRID_DATA',
	IRIS_USER_METADATA: 'gridsModule/gridsPage/IRIS_USER_METADATA',
	GRID_LOADING: 'gridsModule/gridsPage/GRID_LOADING',
	SORTING: 'gridsModule/gridsPage/SORTING',
	QUICK_FILTER: 'gridsModule/gridsPage/QUICK_FILTER',
	ADVANCED_FILTER: 'gridsModule/gridsPage/ADVANCED_FILTER',
	USER_GRIDS_VIEWS: 'gridsModule/gridsPage/USER_GRIDS_VIEWS',
});
import { GeneralActions, GridsActions } from '../../../../actions';
import { processEnum } from '@/enums/processEnum';
import dataService from '../../../../../services/data/projectGridsService';
import exportDataService from '../../../../../services/data/dataExportService';
import fileUtils from '../../../../../utils/fileUtils';
import { ExportMode } from '../../../../../enums/ExportMode';
import Snackbar from '../../../../../components/core/dialogs/snackbarMessage';

//id of the latest grid data request, a response from an older one is ignored so a slow
//load cannot overwrite the rows of the view/filter/page the user switched to meanwhile
let gridDataRequestId = 0;

export default {
	state: {
		gridViews: [],
		gridView: null,
		quickFilter: { FieldId: null, Value: '' },
		advancedFilter: { Operator: 1, Filters: [], FiltersCount: 0 },
		sorting: [],
		rowsPerPage: 50,
		page: 1,
		columns: [],
		loading: false,
		gridData: [],
		irisUsersMetadata: [],
		totalCount: 0,
	},
	mutations: {
		[Mutations.SET_GRID_VIEWS](state, items) {
			state.gridViews = items;
		},
		[Mutations.SET_GRID_VIEW](state, item) {
			state.gridView = item;
		},
		[Mutations.SET_QUICK_FILTER](state, item) {
			state.quickFilter = item;
		},
		[Mutations.SET_ADVANCED_FILTER](state, item) {
			state.advancedFilter = item;
			state.advancedFilter.FiltersCount = item.Filters.length;
		},
		[Mutations.SET_SORTING](state, item) {
			state.sorting = item;
		},
		[Mutations.SET_ROWS_PER_PAGE](state, value) {
			state.rowsPerPage = value;
		},
		[Mutations.SET_PAGE](state, value) {
			state.page = value;
		},
		[Mutations.REPLACE_GRID_VIEW](state, item) {
			let index = state.gridViews.findIndex((x) => x.Id === item.Id);
			state.gridViews.splice(index, 1, item);
		},
		[Mutations.SET_COLUMNS](state, items) {
			state.columns = items;
		},
		[Mutations.UPDATE_GRID_VIEWS](state, item) {
			state.gridViews.forEach((x) => {
				if (x.Id != item.Id) {
					x.IsDefault = false;
				} else {
					if (x.Id == item.Id && item.IsDefault == true) {
						x.IsDefault = true;
					} else {
						x.IsDefault == false;
					}
				}
			});
		},
		[Mutations.SET_LOADING](state, value) {
			state.loading = value;
		},
		[Mutations.SET_GRID_DATA](state, items) {
			state.gridData = items;
		},
		[Mutations.SET_IRIS_USER_METADATA](state, items) {
			state.irisUsersMetadata = items;
		},
		[Mutations.SET_TOTAL_COUNT](state, value) {
			state.totalCount = value;
		},
		[Mutations.SET_TOTAL_COUNT_DELETE](state, count) {
			state.totalCount -= count;
		},
		[Mutations.DELETE_ASSET](state, assetId) {
			let index = state.gridData.findIndex(
				(asset) => asset.Id === assetId
			);
			state.gridData.splice(index, 1);
		},
		[Mutations.DELETE_ASSETS](state, items) {
			items.forEach((x) => {
				let index = state.gridData.findIndex((asset) => asset.Id === x);
				state.gridData.splice(index, 1);
			});
		},
		[Mutations.ADD_GRID_VIEW](state, item) {
			state.gridViews.push(item);
		},
		[Mutations.REMOVE_GRID_VIEW](state, item) {
			let index = state.gridViews.findIndex((g) => g.Id == item.Id);
			state.gridViews.splice(index, 1);
		},
	},
	actions: {
		[Actions.CLEAR]({ commit }) {
			return new Promise((resolve) => {
				//drop any request still in flight, its rows belong to the grid being left
				gridDataRequestId++;
				commit(Mutations.SET_GRID_VIEWS, []);
				commit(Mutations.SET_GRID_VIEW, null);
				commit(Mutations.SET_GRID_DATA, null);
				commit(Mutations.SET_IRIS_USER_METADATA, []);
				commit(Mutations.SET_TOTAL_COUNT, 0);
				commit(Mutations.SET_PAGE, 1);
				commit(Mutations.SET_ROWS_PER_PAGE, 50);
				commit(Mutations.SET_LOADING, false);
				commit(Mutations.SET_SORTING, []);
				commit(Mutations.SET_ADVANCED_FILTER, {
					Operator: 1,
					Filters: [],
					FiltersCount: 0,
				});
				commit(Mutations.SET_QUICK_FILTER, {
					FieldId: null,
					Value: '',
				});
				commit(Mutations.SET_COLUMNS, []);
				commit(Mutations.SET_GRID_VIEW, null);
				resolve();
			});
		},
		[Actions.LOAD_GRID_VIEW_DELETED]({ commit, dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				commit(Mutations.SET_GRID_VIEW, item);
				commit(Mutations.SET_ROWS_PER_PAGE, item.RowsPerPage);
				commit(Mutations.SET_PAGE, 1);
				commit(Mutations.SET_SORTING, item.Sorting);
				commit(
					Mutations.SET_QUICK_FILTER,
					item.QuickFilter || { FieldId: null, Value: '' }
				);
				commit(Mutations.SET_ADVANCED_FILTER, {
					Operator: item.AdvancedFilterOperator || 1,
					Filters: item.AdvancedFilter || [],
				});
				commit(Mutations.SET_COLUMNS, item.Columns);
				//the grid shows its own loader for the rows, stale responses are dropped in LOAD_GRID_DATA
				dispatch(GeneralActions.LOADING, false);
				dispatch(Actions.LOAD_GRID_DATA);
				resolve();
			});
		},
		[Actions.LOAD_GRID_VIEW]({ commit, dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				commit(Mutations.SET_GRID_VIEW, item);
				commit(Mutations.SET_ROWS_PER_PAGE, item.RowsPerPage);
				commit(Mutations.SET_PAGE, 1);
				commit(Mutations.SET_SORTING, item.Sorting);
				commit(
					Mutations.SET_QUICK_FILTER,
					item.QuickFilter || { FieldId: null, Value: '' }
				);
				commit(Mutations.SET_ADVANCED_FILTER, {
					Operator: item.AdvancedFilterOperator || 1,
					Filters: item.AdvancedFilter || [],
				});
				commit(Mutations.SET_COLUMNS, item.Columns);
				//the views list and the rows load in the background, the grid shows its own loader
				//for the rows and stale responses are dropped in LOAD_GRID_DATA
				dataService
					.getGridViews()
					.then((resp) => {
						let data = resp.data.filter(
							(gw) => gw.EntityId == item.EntityId
						);
						commit(Mutations.SET_GRID_VIEWS, data);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
					});
				dispatch(GeneralActions.LOADING, false);
				dispatch(Actions.LOAD_GRID_DATA);
				resolve();
			});
		},
		[Actions.LOAD_GRID_DATA]({ state, commit, dispatch }) {
			return new Promise((resolve) => {
				let requestId = ++gridDataRequestId;
				commit(Mutations.SET_LOADING, true);
				let payload = {
					IncludeCount: true,
					ViewId: state.gridView.Id,
					RowsPerPage: state.rowsPerPage,
					Page: state.page,
					Columns: state.columns
						.filter((x) => x.IsVisible)
						.map((x) => x.Id),
					IncludeDeleted: false,
				};
				if (state.sorting.length > 0) payload.Sorting = state.sorting;
				if (state.advancedFilter.Filters.length > 0)
					payload.AdvancedFilter = state.advancedFilter;
				if (state.quickFilter.Value)
					payload.QuickFilter = state.quickFilter;
				dataService
					.loadData(payload)
					.then((resp) => {
						//a newer request owns the grid and the loader now
						if (requestId !== gridDataRequestId) {
							resolve(false);
							return;
						}
						commit(Mutations.SET_TOTAL_COUNT, resp.data.Count);
						commit(Mutations.SET_GRID_DATA, resp.data.Data);
						commit(
							Mutations.SET_IRIS_USER_METADATA,
							resp.data.IrisUsers
						);
						commit(Mutations.SET_LOADING, false);
						resolve(true);
					})
					.catch((error) => {
						if (requestId !== gridDataRequestId) {
							resolve(false);
							return;
						}
						dispatch(GeneralActions.ERROR, error);
						commit(Mutations.SET_LOADING, false);
						resolve(false);
					});
			});
		},
		[Actions.UPDATE_GRID_VIEW_FIELDS]({ commit, dispatch, state }, value) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				let gridViewId = state.gridView.Id;
				let columns = value.map(({ Id, Order, IsVisible }) => ({
					Id,
					Order,
					IsVisible,
				}));
				dataService
					.updateColumns(gridViewId, columns)
					.then((resp) => {
						let gridView = resp.data;
						commit(Mutations.SET_GRID_VIEW, gridView);
						commit(Mutations.SET_COLUMNS, gridView.Columns);
						dispatch(GeneralActions.LOADING, false);
						dispatch(Actions.LOAD_GRID_DATA);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve(false);
					});
			});
		},
		[Actions.SET_DEFAULT_GRID_VIEW]({ commit, dispatch, state }, view) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.setDefaultView(view.Id, state.gridView.Id, view.IsDefault)
					.then(() => {
						return dataService.getGridViewById(state.gridView.Id);
					})
					.then(() => {
						commit(Mutations.UPDATE_GRID_VIEWS, view);
						commit(Mutations.SET_GRID_VIEW, view);
						//the grids module caches the views list for the whole session and Grid.vue
						//reads the default out of it on every navigation, so it has to be told
						return dispatch(GridsActions.RELOAD_GRID_VIEWS);
					})
					.then(() => {
						return dispatch(Actions.LOAD_GRID_VIEW, view);
					})
					.then(() => {
						dispatch(GeneralActions.LOADING, false);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve(false);
					});
			});
		},
		[Actions.SET_GLOBAL_GRID_VIEW]({ commit, dispatch }, view) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.setGlobalView(view.Id, view.IsGlobal === true)
					.then((resp) => {
						commit(Mutations.REPLACE_GRID_VIEW, resp.data);
						//keep the session wide views list in step, it feeds the next navigation
						return dispatch(GridsActions.RELOAD_GRID_VIEWS);
					})
					.then(() => {
						dispatch(GeneralActions.LOADING, false);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve(false);
					});
			});
		},
		[Actions.UPDATE_GRID_VIEW]({ commit, dispatch, state }, id) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				// let columns= state.columns.map(({Id , Order}) => ({Id,Order}));
				let gridView = {
					Id: id,
					Name: state.gridView.Name,
					RowsPerPage: state.rowsPerPage,
					Columns: state.columns
						.filter((x) => x.IsVisible)
						.sort((a, b) => a.Order - b.Order)
						.map((x) => x.Id),
					AdvancedFilter: state.advancedFilter,
					Sorting: state.sorting,
				};
				let gv = null;
				dataService
					.updateView(gridView)
					.then((resp) => {
						gv = resp.data;
						commit(Mutations.SET_GRID_VIEW, gv);
						commit(Mutations.SET_COLUMNS, gv.Columns);
						commit(Mutations.SET_ADVANCED_FILTER, {
							Operator: resp.data.AdvancedFilterOperator,
							Filters: resp.data.AdvancedFilter,
						});
						commit(Mutations.REPLACE_GRID_VIEW, resp.data);
						return dispatch(GridsActions.RELOAD_GRID_VIEWS);
					})
					.then(() => {
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.SAVE_GRID_VIEW]({ commit, dispatch, state }, payload) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				//the payload used to be the view name alone, it now also carries the Global View flag
				let view =
					typeof payload === 'string' ? { Name: payload } : payload;
				// let columns= state.columns.map(({Id , Order}) => ({Id,Order}));
				let gridView = {
					Name: view.Name,
					IsGlobal: view.IsGlobal === true,
					RowsPerPage: state.rowsPerPage,
					EntityId: state.gridView.EntityId,
					Columns: state.columns,
					AdvancedFilter: state.advancedFilter,
					Sorting: state.sorting,
				};
				let gv = null;
				dataService
					.saveView(gridView)
					.then((resp) => {
						gv = resp.data;
						commit(Mutations.SET_GRID_VIEW, gv);
						commit(Mutations.SET_COLUMNS, gv.Columns);
						return dataService.getGridViewById(state.gridView.Id);
					})
					.then((resp) => {
						commit(Mutations.SET_GRID_VIEW, resp.data);
						commit(Mutations.ADD_GRID_VIEW, resp.data);
						//keep the session wide views list in step, it feeds the next navigation
						return dispatch(GridsActions.RELOAD_GRID_VIEWS);
					})
					.then(() => {
						dispatch(GeneralActions.LOADING, false);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve(false);
					});
			});
		},
		[Actions.UPDATE_PAGE]({ commit, dispatch }, value) {
			commit(Mutations.SET_PAGE, value);
			dispatch(Actions.LOAD_GRID_DATA);
		},
		[Actions.UPDATE_ROWS_PER_PAGE]({ commit, dispatch }, value) {
			commit(Mutations.SET_ROWS_PER_PAGE, value);
			commit(Mutations.SET_PAGE, 1);
			dispatch(Actions.LOAD_GRID_DATA);
		},
		[Actions.UPDATE_SORTING]({ commit, dispatch }, value) {
			commit(Mutations.SET_SORTING, value);
			commit(Mutations.SET_PAGE, 1);
			dispatch(Actions.LOAD_GRID_DATA);
		},
		[Actions.UPDATE_QUICK_FILTER]({ commit, dispatch }, value) {
			commit(Mutations.SET_QUICK_FILTER, value);
			commit(Mutations.SET_PAGE, 1);
			dispatch(Actions.LOAD_GRID_DATA);
		},
		[Actions.UPDATE_ADVANCED_FILTER]({ commit, dispatch }, value) {
			commit(Mutations.SET_ADVANCED_FILTER, value);
			commit(Mutations.SET_PAGE, 1);
			dispatch(Actions.LOAD_GRID_DATA);
		},
		[Actions.DELETE_GRID_VIEW]({ commit, dispatch, state }, view) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				let reload = view.Id === state.gridView.Id;
				dataService
					.deleteView(view.Id, state.gridView.Id)
					.then(() => {
						commit(Mutations.REMOVE_GRID_VIEW, view);
						//keep the session wide views list in step, it feeds the next navigation
						return dispatch(GridsActions.RELOAD_GRID_VIEWS);
					})
					.then(() => {
						return dataService.getGridViewById(state.gridView.Id);
					})
					.then((resp) => {
						commit(Mutations.SET_GRID_VIEW, resp.data);
						dispatch(GeneralActions.LOADING, false);
						if (reload) {
							dispatch(
								Actions.LOAD_DEFAULT_GRID_VIEW_FOR_ENTITY,
								state.gridView.UserId
							);
						}
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve(false);
					});
			});
		},
		[Actions.DELETE_ASSET]({ commit }, data) {
			dataService
				.deleteGridAsset(
					data.id,
					data.entityType,
					data.entityId,
					processEnum.EditGrid
				)
				.then(() => {
					commit(Mutations.DELETE_ASSET, data.id);
					commit(Mutations.SET_TOTAL_COUNT_DELETE, 1);
				});
		},
		[Actions.DELETE_BULK_ASSETS]({ commit, dispatch }, data) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.deleteBulkGridAsset(
						data.items,
						data.entityType,
						data.entityId,
						processEnum.EditGrid
					)
					.then(() => {
						commit(Mutations.DELETE_ASSETS, data.items);
						commit(
							Mutations.SET_TOTAL_COUNT_DELETE,
							data.items.length
						);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.EXPORT_CURRENT_GW_PAGE](
			{ dispatch, state },
			{ timeZone, isDirectMode = ExportMode.DIRECT }
		) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				let payload = {
					IncludeCount: true,
					ViewId: state.gridView.Id,
					RowsPerPage: state.rowsPerPage,
					Page: state.page,
					TimeZone: timeZone,
					Columns: state.columns
						.filter((x) => x.IsVisible)
						.sort((a, b) => a.Order - b.Order)
						.map((x) => x.Id),
				};
				if (state.sorting.length > 0) payload.Sorting = state.sorting;
				if (state.advancedFilter.Filters.length > 0)
					payload.AdvancedFilter = state.advancedFilter;
				if (state.quickFilter.Value)
					payload.QuickFilter = state.quickFilter;
				if (isDirectMode === ExportMode.DIRECT) {
					exportDataService
						.downloadGridViewDirect(payload)
						.then((resp) => {
							const fileInfo =
								fileUtils.extractFileInfoFromResponse(resp);
							const blob = new Blob([resp.data], {
								type: fileInfo.mimeType,
							});
							const url = window.URL.createObjectURL(blob);
							const link = document.createElement('a');
							link.href = url;

							link.setAttribute('download', fileInfo.filename);
							document.body.appendChild(link);
							link.click();

							// Clean up resources
							document.body.removeChild(link);
							window.URL.revokeObjectURL(url);

							resolve(true);
						})
						.catch((error) => {
							dispatch(GeneralActions.ERROR, error);
							resolve(false);
						})
						.finally(() => {
							dispatch(GeneralActions.LOADING, false);
						});
				} else {
					// Background export mode
					exportDataService
						.downloadGridView(payload)
						.then(() => {
							// Background export - show notification
							Snackbar({
								message:
									'Export request registered. You will receive a notification when the file is ready for download!',
								timeout: 5000,
							});
							resolve(true);
						})
						.catch((error) => {
							dispatch(GeneralActions.ERROR, error);
							resolve(false);
						})
						.finally(() => {
							dispatch(GeneralActions.LOADING, false);
						});
				}
			});
		},
		[Actions.EXPORT_ALL_DATA](
			{ dispatch, state },
			{ timeZone, isDirectMode = ExportMode.DIRECT }
		) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				let payload = {
					IncludeCount: true,
					ViewId: state.gridView.Id,
					RowsPerPage: state.totalCount,
					Page: 1,
					TimeZone: timeZone,
					Columns: state.columns
						.filter((x) => x.IsVisible)
						.sort((a, b) => a.Order - b.Order)
						.map((x) => x.Id),
				};
				if (state.sorting.length > 0) payload.Sorting = state.sorting;
				if (state.advancedFilter.Filters.length > 0)
					payload.AdvancedFilter = state.advancedFilter;
				if (state.quickFilter.Value)
					payload.QuickFilter = state.quickFilter;
				if (isDirectMode === ExportMode.DIRECT) {
					exportDataService
						.downloadGridViewDirect(payload)
						.then((resp) => {
							const fileInfo =
								fileUtils.extractFileInfoFromResponse(resp);
							const blob = new Blob([resp.data], {
								type: fileInfo.mimeType,
							});
							const url = window.URL.createObjectURL(blob);
							const link = document.createElement('a');
							link.href = url;

							link.setAttribute('download', fileInfo.filename);
							document.body.appendChild(link);
							link.click();

							// Clean up resources
							document.body.removeChild(link);
							window.URL.revokeObjectURL(url);

							resolve(true);
						})
						.catch((error) => {
							dispatch(GeneralActions.ERROR, error);
							resolve(false);
						})
						.finally(() => {
							dispatch(GeneralActions.LOADING, false);
						});
				} else {
					// Background export mode
					exportDataService
						.downloadGridView(payload)
						.then(() => {
							// Background export - show notification
							Snackbar({
								message:
									'Export request registered. You will receive a notification when the file is ready for download!',
								timeout: 5000,
							});
							resolve(true);
						})
						.catch((error) => {
							dispatch(GeneralActions.ERROR, error);
							resolve(false);
						})
						.finally(() => {
							dispatch(GeneralActions.LOADING, false);
						});
				}
			});
		},
	},
	getters: {
		[Getters.GRID_VIEW]: (state) => {
			return state.gridView;
		},
		[Getters.PAGE]: (state) => {
			return state.page;
		},
		[Getters.ROWS_PER_PAGE]: (state) => {
			return state.rowsPerPage;
		},
		[Getters.VISIBLE_COLUMNS]: (state) => {
			if (!state.columns) return [];
			let visibleColumns = state.columns
				.filter((x) => x.IsVisible === true)
				.sort((a, b) => a.Order - b.Order);
			return JSON.parse(JSON.stringify(visibleColumns));
		},
		[Getters.HIDDEN_COLUMNS]: (state) => {
			if (!state.columns) return [];
			let hiddenColumns = state.columns
				.filter((x) => x.IsVisible === false)
				.sort((a, b) => a.Order - b.Order);
			return JSON.parse(JSON.stringify(hiddenColumns));
		},
		[Getters.TOTAL_COUNT]: (state) => {
			return state.totalCount;
		},

		[Getters.GRID_DATA]: (state) => {
			if (!state.gridData) return [];
			return JSON.parse(JSON.stringify(state.gridData));
		},

		[Getters.IRIS_USER_METADATA]: (state) => {
			if (!state.irisUsersMetadata) return [];
			if (state.irisUsersMetadata.length <= 0) return [];
			return JSON.parse(JSON.stringify(state.irisUsersMetadata));
		},
		[Getters.SORTING]: (state) => {
			return JSON.parse(JSON.stringify(state.sorting));
		},
		[Getters.GRID_LOADING]: (state) => {
			return state.loading;
		},
		[Getters.QUICK_FILTER]: (state) => {
			return JSON.parse(JSON.stringify(state.quickFilter));
		},
		[Getters.ADVANCED_FILTER]: (state) => {
			if (!state.advancedFilter) return [];
			return JSON.parse(JSON.stringify(state.advancedFilter));
		},
		[Getters.USER_GRIDS_VIEWS]: (state) => {
			if (!state.gridViews) return [];
			return JSON.parse(JSON.stringify(state.gridViews));
		},
		[Getters.DEFAULT_GRID_VIEW]: (state) => {
			if (state.gridViews.length == 0) return [];
			let defaultGw = state.gridViews.find(
				(gw) => gw.UserId == null && gw.Type == 1
			);
			return defaultGw;
		},
	},
};
